import { axios } from '@lib/axios';

import {
    EntryTypeSpecialtyCreationForm,
    EntryTypeSpecialtyData,
    EntryTypeSpecialtyListResponse,
    EntryTypeSpecialtyQueryParams,
    EntryTypeSpecialtyUpdateForm,
} from 'chaika-frontend-types/frontend-cms';

const BASE_URL = '/api/entry-type-specialty';

export class EntryTypeSpecialtyApi {
    public static async create(params: EntryTypeSpecialtyCreationForm): Promise<void> {
        await axios.post(`${BASE_URL}`, params);
    }

    public static async getById(id: string): Promise<EntryTypeSpecialtyData> {
        const res = await axios.get<EntryTypeSpecialtyData>(`${BASE_URL}/${id}`);

        return res.data;
    }

    public static async find(params: EntryTypeSpecialtyQueryParams): Promise<EntryTypeSpecialtyListResponse> {
        const res = await axios.get<EntryTypeSpecialtyListResponse>(`${BASE_URL}`, { params });

        return res.data;
    }

    public static async update(id: string, params: EntryTypeSpecialtyUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, params);
    }

    public static async delete(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }
}
